import React from 'react';
import mainLogo from '../../assets/logo/large-K-icon.png'
import { Grid, Paper } from '@mui/material';
import { withRouter } from "react-router";
import { ContainedButton } from "../common/StyledButtons";
import StyledLogo from '../common/StyledLogo';
import { DEFAULT_INTERNAL_URL } from '../../constants/Constants';
import StyledPage from '../common/StyledPage';


const GenericNotFound = ({ history }) => {
  
  const handleBack = () => {
    const referrer = document.referrer;
    const isInternalReferrer = referrer && referrer.includes(window.location.origin);

    if (isInternalReferrer) {
      history.goBack();
    } else {
      history.replace(DEFAULT_INTERNAL_URL);
    }
  };

  return (
    <StyledPage>
      <div style={{height:'auto', position: 'relative', marginTop: 150 }}>
        <Grid container justifyContent='center'>
          <Grid item xs={'auto'}>
          <StyledLogo logoProps={{ height: 60}}/>
          </Grid>
        </Grid>
        <Grid container justifyContent='center' style={{ marginTop: 28 }}>
          <Grid xs={11} md={6}>
            <Paper style={{ padding: 32 }} variant='outlined'>
              <h3 style={{ textAlign: 'center', margin: 0, padding: 0 }}>Oh snap!</h3>
              <p style={{ textAlign: 'center' }}>It looks like this page has gone missing. Let's get you back on track! Please check the link, or press the button below to return to the previous page.</p>
              <Grid container justifyContent='center' style={{ marginTop: 28 }}>
                <ContainedButton onClick={handleBack}>
                  Go Back
                </ContainedButton>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </div>
    </StyledPage>
  )
};

export default withRouter(GenericNotFound);
